namespace RedBullMOBILE360.Administration {
    export interface UserRoleListRequest extends Serenity.ServiceRequest {
        UserID?: number;
    }
}

